export const statusChange = 'LineItemStatusChange';
export const priceChange = 'LineItemPriceChange';
